/* eslint-disable i18next/no-literal-string */
import {Text} from '@dropbox/dig-components/typography';
import {Stack} from '@dropbox/dig-foundations';
import type {AskHealthWeek} from 'client';
import {MiniChart} from 'components/DSYS/MiniChart';

import {weekLabel} from './format';
import {Panel} from './Panel';

export type WeeklySeries = {
  name: string;
  value: (week: AskHealthWeek) => number | null | undefined;
};

/** A line per series over weeks, or over days when `byDay` (until two weeks exist). */
export const WeeklyChart = ({
  title,
  description,
  weeks,
  series,
  label = weekLabel,
  byDay = false,
}: {
  title: string;
  description: string;
  weeks: AskHealthWeek[];
  series: WeeklySeries[];
  label?: (week: AskHealthWeek) => string;
  byDay?: boolean;
}) => {
  // MiniChart takes plain numbers, so plot only the periods every line has.
  const plotted = weeks.filter((week) => series.every((s) => s.value(week) != null));
  return (
    <Panel>
      <Stack gap="8">
        <Text tagName="div" isBold>
          {title}
          {byDay ? (
            <Text size="small" color="subtle">
              {' '}
              · by day
            </Text>
          ) : null}
        </Text>
        <Text tagName="div" size="small" color="subtle">
          {description}
        </Text>
        {plotted.length >= 2 ? (
          <MiniChart
            height={160}
            graph={{
              kind: 'line',
              labelHeader: byDay ? 'Day' : 'Week',
              labels: plotted.map(label),
              series: series.map((s) => ({
                name: s.name,
                values: plotted.map((week) => s.value(week) ?? 0),
              })),
            }}
          />
        ) : (
          <Text tagName="div" size="small" color="subtle">
            A chart appears once there are two {byDay ? 'days' : 'weeks'} of data.
          </Text>
        )}
      </Stack>
    </Panel>
  );
};
